var render = function render(){var _vm=this,_c=_vm._self._c;return _c('config-item',{attrs:{"label":_vm.label}},[_c('FaRichText',_vm._b({attrs:{"placeholder":_vm.mOptions.placeholder},model:{value:(_vm.mValue),callback:function ($$v) {_vm.mValue=$$v},expression:"mValue"}},'FaRichText',_vm.mOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }